'use client';
import Header from '@/components/common/Header';
import FixturesHero from './components/FixturesHero';
import FixturesContent from './components/FixturesContent';
import { useState, useEffect } from 'react';
import { fixtureService } from '../../services/fixtureService';
import { Fixture } from '../../types/fixtures.types';

export default function FixturesPage() {
  const [fixtures, setFixtures] = useState<Fixture[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadFixtures();
  }, []);

  const loadFixtures = async () => {
    try {
      setLoading(true);
      const data = await fixtureService.getUpcomingFixtures();
      setFixtures(data);
    } catch (error) {
      console.error('Error loading fixtures:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Header data-component-id="src/app/fixtures/page.tsx:31:6" data-component-path="src/app/fixtures/page.tsx" data-component-line="31" data-component-end-line="31" data-component-file="page.tsx" data-component-name="Header" data-component-content="%7B%22elementName%22%3A%22Header%22%7D" />
      <FixturesHero data-component-id="src/app/fixtures/page.tsx:32:6" data-component-path="src/app/fixtures/page.tsx" data-component-line="32" data-component-end-line="32" data-component-file="page.tsx" data-component-name="FixturesHero" data-component-content="%7B%22elementName%22%3A%22FixturesHero%22%7D" />
      <FixturesContent data-component-id="src/app/fixtures/page.tsx:33:6" data-component-path="src/app/fixtures/page.tsx" data-component-line="33" data-component-end-line="33" data-component-file="page.tsx" data-component-name="FixturesContent" data-component-content="%7B%22elementName%22%3A%22FixturesContent%22%7D" fixtures={fixtures} loading={loading} />
    </>
  );
}